import template from './component.tpl.html';
import AlGuestlistGridEntryController from './controller';

angular
    .module('festzelt-os.modules.guestlists')
    .component('alGuestlistGridEntry', {
        bindings: {
            guestlist: '<',
            onTriggerReload: '&'
        },
        controller: AlGuestlistGridEntryController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlists-grid-view/sub-components/al-guestlist-grid-entry/component.js